export default "__VITE_ASSET__650d33ae__"